import Vue from 'vue';

const state = {
    id: null,
    name: null,
    phone: null,
    action_id: null,
    actions: [],
};

const mutations = {
    changeActionParams(state, items) {
        state = Object.assign(state, items)
    },
    setActionBlank(state) {
        state.name = null;
        state.phone = null;
        state.action_id = null;
    },

};

const getters = {
    getActionName: state => state.name,
    getActionPhone: state => state.phone,
    getActionId: state => state.id,
    getActionItemId: state => state.action_id,
    getActions: state => state.actions,
};

const actions = {
    changeAction({commit}, items) {
        commit('changeActionParams', items);
    },
    setActionName({commit}, value) {
        commit('changeActionParams', {name: value});
    },
    setActionPhone({commit}, value) {
        commit('changeActionParams', {phone: value});
    },
    setActionItemId({commit}, value) {
        commit('changeActionParams', {action_id: null});
    },
    setActiveActions({commit}) {
        commit('createProcess', 'setActiveActions');
        Vue.http.get(this.getters.getApiUrl + 'v1/actions/get-active').then(response => {
            commit('changeActionParams', {actions: response.data});
            if (response.data.length > 0)
                commit('changeActionParams', {action_id: response.data[0].id});
            commit('setProcessSuccess', 'setActiveActions');
        }, response => {
            commit('setProcessFailed', {id: 'setActiveActions', message: response.body.message, code: response.status});
        });
    },
    setAllActions({commit}) {
        commit('createProcess', 'setActiveActions');
        Vue.http.get(this.getters.getApiUrl + 'v1/actions?access-token=' + this.getters.getSystemAccessToken).then(response => {
            commit('changeActionParams', {actions: response.data});
            if (response.data.length > 0)
                commit('changeActionParams', {actions: response.data});
            commit('setProcessSuccess', 'setActiveActions');
        }, response => {
            commit('setProcessFailed', {id: 'setActiveActions', message: response.body.message, code: response.status});
        });
    },
    setActionLid({commit}) {
        commit('createProcess', 'setActionLid');
        let params = {
            'name': state.name,
            'phone': state.phone,
            'action_id': state.action_id
        };
        Vue.http.post(this.getters.getApiUrl + 'v1/action-contracts', params).then(response => {
            commit('setProcessSuccess', 'setActionLid');
            commit('changeActionParams', {id: response.data.id});
        }, response => {
            commit('setProcessFailed', {id: 'setActionLid', message: response.body.message, code: response.status});
        });
    },
    clearAction({commit}) {
        commit("setActionBlank");
    }
};

export default {
    state,
    mutations,
    getters,
    actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/actions.js